import { ReactNode } from 'react';
import { SectionHeader } from '../../common/SectionHeader';
import {
  MicrophoneIcon,
  PlayCircleIcon,
  BookIcon,
  LockIcon,
  SettingsIcon,
  UploadIcon,
} from '../../../assets/icons';
import styles from './FeaturesSection.module.css';

interface Feature {
  icon: ReactNode;
  title: string;
  description: string;
}

const FEATURES: Feature[] = [
  {
    icon: <MicrophoneIcon />,
    title: 'Real-Time Transcription',
    description: "Instant speech-to-text conversion with industry-leading accuracy. See words appear as they're spoken.",
  },
  {
    icon: <PlayCircleIcon />,
    title: 'Spatial Positioning',
    description: 'Captions hover in your field of view, anchored in space exactly where you need them.',
  },
  {
    icon: <BookIcon />,
    title: 'Multi-Language Support',
    description: 'Transcribe and translate 50+ languages in real-time. Break down communication barriers.',
  },
  {
    icon: <LockIcon />,
    title: 'Privacy First',
    description: 'All processing happens on-device. Your conversations stay private and secure.',
  },
  {
    icon: <SettingsIcon />,
    title: 'Customizable Display',
    description: 'Adjust font size, color, position, and transparency. Make captions work for your vision.',
  },
  {
    icon: <UploadIcon />,
    title: 'Export & Share',
    description: 'Save transcriptions for later. Export to text, share with colleagues, or review conversations.',
  },
];

const FeatureCard = ({ icon, title, description }: Feature) => (
  <div className={styles.featureCard}>
    <div className={styles.featureIcon}>{icon}</div>
    <h3>{title}</h3>
    <p>{description}</p>
  </div>
);

export const FeaturesSection = () => {
  return (
    <section className={styles.features} id="features">
      <SectionHeader
        label="Capabilities"
        title="Designed for the way you live"
        subtitle="Every feature crafted for seamless integration into your spatial computing experience."
      />
      <div className={styles.featuresGrid}>
        {FEATURES.map((feature, index) => (
          <FeatureCard key={index} {...feature} />
        ))}
      </div>
    </section>
  );
};
